import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { profile, type Profile } from '@/data/profile';

export const profileApi = createApi({
  reducerPath: 'profileApi',
  baseQuery: fakeBaseQuery(),
  tagTypes: ['Profile'],
  endpoints: (builder) => ({
    getProfile: builder.query<Profile, void>({
      queryFn: async () => ({ data: profile }),
      providesTags: ['Profile'],
    }),
  }),
});

export const { useGetProfileQuery } = profileApi;
